import clsx from 'clsx';
import type { MouseEventHandler } from 'react';
import useTestTag from '../../../../common/hooks/use-test-tag';
import { IconButton } from '../../../button/button';
import { OdinIconSize } from '../../../odin-icon/odin-icon.component';

interface FilterChipProps {
  text?: string;
  onClear: MouseEventHandler<HTMLButtonElement>;
}

const FilterChip = ({ text, onClear }: FilterChipProps) => {
  const tagCreator = useTestTag('filter-chip');

  const currentValueStyles = clsx(
    'odin-flex odin-items-center odin-justify-between odin-grow odin-min-w-0 odin-text-primary-1',
    'odin-border odin-border-transparent odin-rounded-full odin-px-3 odin-text-xs odin-h-5 odin-mr-2',
    {
      '!odin-border-primary-1': text,
    }
  );

  return (
    <div
      className={currentValueStyles}
      title={text}
      ref={tagCreator(text ? text.replace(/\s+/g, '-').toLowerCase() : 'filter-value')}
    >
      <p className="odin-truncate">{text}</p>
      {text && <IconButton onClick={onClear} icon="X" iconSize={OdinIconSize.ExtraSmall} />}
    </div>
  );
};

export default FilterChip;
